export default "__VITE_ASSET__DfM3q69E__"